// AUTO-GENERATED by scripts/build-registry.js: study entry for air-law/post-landing-taxi-procedures.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/air-law/post-landing-taxi-procedures/hiro.js';
import g1 from '../lessons/air-law/post-landing-taxi-procedures/post-landing-taxi-procedures.js';

mount([g0, g1]);
